import { MultiSelection } from '../../../shared/checkbox-list/entities/multi-selection.entity';

export class MemosFilters {
	perimetreGeographique: number = 0;
	agenceId: number | null = null;
	antenneIdsSelection: MultiSelection | undefined = undefined;
	parcIdsSelection: MultiSelection | undefined = undefined;
	sousParcsIdsSelection: MultiSelection | undefined = undefined;
	ouvrageIdsSelection: MultiSelection | undefined = undefined;
	parcMaintenanceIdsSelection: MultiSelection | undefined = undefined;
	parcTechnologieIdsSelection: MultiSelection | undefined = undefined;
	memoCategoryIdsSelection: MultiSelection | undefined = undefined;
	memoStatusSelection: MultiSelection | undefined = undefined;

	constructor() {
	}
}